<div class="fixed-top custombg" style=" z-index: 100;">
    <div class="d-flex flex-column">
        <app-header #header></app-header>
        <app-breadcrumb></app-breadcrumb>
    </div>
</div>

<div class="wrapper row mainclass" id="main-class-padding">
    <div class="display-block">
        <!-- Project Details -->
        <app-project-detail [auditId]="auditId"></app-project-detail>
        <!-- Reviewer -->
        <div class="projectInfo statusTitle reviewstyle"
        style="display: flex; flex-direction: row; text-align: center; padding: 10px 16px;">
       <div class="title">
           <span id="textTitle">Reviewer Name: &nbsp;</span>
       </div>
       <div class="status" style="padding-top: 5px;">
           <span id="status-text">{{ reviewerName }}</span>
       </div>
   </div>

<div *ngIf="isPopupOpen" class="popup-overlay">
      <div class="popup-dialog">
        <h1 mat-dialog-title>Add Questions</h1>
        <div mat-dialog-content>
       <form (ngSubmit)="onSubmit()">
            <mat-form-field appearance="outline" style="width: 100%; margin-top: 15px;">
                <mat-label class="h5 label-bold">Add Question</mat-label>
                <textarea matInput [(ngModel)]="questionText" name="questionText" rows="4" required></textarea>
            </mat-form-field>
            <mat-label class="h5 label-bold">SubCategory</mat-label>
            <mat-select class="form-control custom-mat-single-select file-type fs-14 black-clr" placeholder="Select" [(ngModel)]="selectedSubCategory" required>
                <mat-option *ngFor="let data of tableData" [value]="data.category">
                    {{ data.category }}
                </mat-option>
            </mat-select>
            <div mat-dialog-actions class="closebtn justify-content-end">
                <button mat-dialog-close class="custom_btn inverted_btn_base can_btn" (click)="closePopup()">Cancel</button>
                <button mat-flat-button class="custom_btn primary_btn_base d-flex add_btn">Add</button>
            </div> 
        </form>
     </div>
    </div>
</div>
        <!-- Questions Table -->
        <div class="table-container">
            <button mat-flat-button class="btn_blue competency_btn" (click)="openPopup()">+ Add Question</button>
            <span id="stagetext">{{stage}}</span>
            <table>
                <thead>
                    <tr>
                        <th style="width:200px">Category</th>
                        <th>Audit</th>
                        <th style="width:100px">Weightage</th>
                        <th colspan="3" style="width:150px">Comments</th>
                        <th>Auditor</th>
                    </tr>
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th style="width:100px;">Response</th>
                        <th style="width:100px;">Supporting Material</th>
                        <th style="width:150px;">Observations, Exceptions and Reason for Non Compliance. </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of tableData">
                        <td>{{ data.category }}</td>
                        <td style="text-align: start;">{{ data.questions }}</td>
                        <td>{{ data.weightage }}</td>
                        <td class="dropdown">
                            <select placeholder="select" [(ngModel)]="data.selectedResponseOption">
                                <option disabled selected hidden value=0>Select Response</option>
                                <option *ngFor="let option of responseDropDownOptions" [value]="option.id">
                                    {{option.description}}</option>
                            </select>
                        </td>
                        <td class="dropdown">
                            <select [(ngModel)]="data.supportingMaterial">
                                <option [ngValue]=0 disabled selected hidden>Select Supporting Material</option>
                                <option [ngValue]="true">True</option>
                                <option [ngValue]="false">False</option>
                            </select>
                        </td>
                        <td><input type="text" [(ngModel)]="data.comment" placeholder="Enter Comments"></td>
                        <td><input type="text" [(ngModel)]="data.auditorComment" placeholder="Enter Comments"></td>
                    </tr>
                </tbody>
            </table>


            <div class="buttons">
                <span *ngIf="1 < 0" class="align-middle submit-error-message"
                    [ngClass]="{'text-success':!isError,'text-danger': isError}"> {{questionSaveErrorMessage}}</span>
                <button class="custom_btn inverted_btn_base mr-2" style="float:right"
                    (click)="navigateBackToProjectOverview()">Back</button>
                <button class="custom_btn primary_btn_base mr-2" (click)="sendNotification()">Clarification
                    Needed</button>
                <button class="custom_btn inverted_btn_base mr-2" (click)="resetQuestionTable()">Clear</button>
                <button (click)="saveQuestionTableResponseData()" class="custom_btn primary_btn_base">Save</button>
            </div>
        </div>

        <!-- Review -->
        <div class="finalReview mt-2">
            <div class="rating">
                <div class="starText">
                    <span id="stagetext">Rating&nbsp; : &nbsp;</span>
                    <div class="star-icons">
                        <span *ngFor="let start of createRange(stageReviewDetails?.rating)">
                            <i class="fa fa-star" *ngIf="stageReviewDetails"></i>
                        </span>
                    </div>

                    <div class="star-icons" *ngIf="stageReviewDetails?.rating < 1">
                        <div class="containet">
                            <input type="radio" name="clr" style="--c: #ff9933" value="5"
                                (change)="ratingChangeHandler($event)" />
                            <input type="radio" name="clr" style="--c: #ff9933" value="4"
                                (change)="ratingChangeHandler($event)" />
                            <input type="radio" name="clr" style="--c: #ff9933" value="3"
                                (change)="ratingChangeHandler($event)" />
                            <input type="radio" name="clr" style="--c: #ff9933" value="2"
                                (change)="ratingChangeHandler($event)" />
                            <input type="radio" name="clr" style="--c: #ff9933" value="1"
                                (change)="ratingChangeHandler($event)" />
                        </div>
                    </div>
                </div>
                <div class="buttonsmain">
                    <div class="auditorComments">
                        <span id="stagetext">Auditor Comments</span>
                        <input type="text" [(ngModel)]="reviewComment" name="textReviewComment"
                               placeholder="Enter comment text here" class="custom-input"
                               [disabled]="isCommentDisabled">
                      </div>                      
                    <div class="buttons m-b-4">
                        <span *ngIf="1 < 0" class="align-middle submit-error-message"
                            [ngClass]="{'text-success':!isError,'text-danger': isError}">
                            {{reviewSaveErrorMessage}}</span>
                        <button class="custom_btn primary_btn_base" (click)="submitCategoryReview()"
                            title="Submit Category Review" *ngIf="ratingId < 1 && !hideSubmitButton">Submit</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>